import React from 'react';
import { BaasicTextAreaTemplate } from 'themes/components';

function BaasicTextArea(props) {
	return <BaasicTextAreaTemplate {...props} />;
}

export default BaasicTextArea;
